<template>
  <div id="PressFeedingRecord">
    <el-form :model="searchForm" ref="form" label-width="0" :inline="false" size="small">
      <el-card class="table_searchbar">
        <el-row :gutter="20" style="margin-bottom: 20px">
          <el-col :span="10" style="display: flex">
            <div class="" @keydown.enter="clickSearch()">
              <span class="title">日期：</span>
              <el-date-picker
                style="width: 500px"
                v-model="searchForm.date"
                type="daterange"
                range-separator="-"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="deadlineOption"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" style="display: flex">
            <div class="" @keydown.enter="clickSearch()">
              <span class="title">物料信息：</span>
              <el-input
                placeholder="物料信息"
                v-model="searchForm.materialId"
                style="width: 180px"
                :maxlength="20"
              ></el-input>
              <!-- <el-select clearable filterable size="small" :loading="loading" @clear="clearSearchMaterial(1)"
								@visible-change="ev => {
										if (!ev) {
											remoteMethod(1, '');
										}
									}
									" :remote-method="query => remoteMethod(1, query)" remote style="max-width:180px;"
								v-model="searchForm.materialId" placeholder="物料编码">
								<el-option v-for="item in materialList" :key="item.materialId" :label="item.materialCode"
									:value="item.materialId"></el-option>
							</el-select> -->
            </div>
          </el-col>
          <el-col :span="9">
            <div style="text-align: right">
              <el-button
                icon="el-icon-search"
                size="mini"
                type="primary"
                v-if="permission.btn_utilization_list"
                @click="clickSearch(1)"
              >
                查询</el-button
              >
              <el-button size="mini" icon="el-icon-refresh" @click="clearSearch"
                >重置</el-button
              >
              <el-button size="mini" icon="el-icon-download" @click="exportList"
                >导出</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
    <div class="topChart">
      <div id="historyChart"></div>
    </div>
    <el-card class="tab table-card">
      <el-table :data="tableData" stripe width="100%" class="table_data" :maxHeight="380">
        <el-table-column
          prop="materialCode"
          min-width="100"
          label="物料编号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="materialName"
          min-width="100"
          label="物料名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="specification"
          min-width="120"
          label="规格"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="procedureName"
          min-width="100"
          label="工序名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="qtCount"
          min-width="80"
          label="质检次数"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="inspectCount"
          min-width="80"
          label="质检数"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="qualifiedCount"
          min-width="80"
          label="合格数"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="unQualifiedCount"
          min-width="80"
          label="不合格数"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="reworkCount"
          min-width="80"
          label="返工数"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="scrappedCount"
          min-width="80"
          label="报废数"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="concessionCount"
          min-width="80"
          label="让步接收数"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <div
        class="page"
        v-if="page.total > 0"
        style="margin-bottom: 36px; margin-top: -10px"
      >
        <div class="total_page" style="margin-top: 22px">
          <span> 共{{ page.total }}条</span>
        </div>
        <div style="margin-top: 16px; text-align: right; margin-bottom: 10px">
          <el-pagination
            background
            @size-change="sizeChange"
            layout=" sizes, prev, pager, next, jumper"
            :page-count="tableTotalPage"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size.sync="page.pageSize"
            :total="tableTotalPage"
            @current-change="pageChange"
            :current-page.sync="tableCurrentPage"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "UnqualifiedReport",

  data() {
    return {
      isChange: false,
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      months: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ],
      historyYear: new Date(),
      proportionChart: {},
      historyChart: {},
      showMore: false,
      deadlineOption: {
        disabledDate(time) {
          // 今天之前的时间
          if (time.getTime() > new Date().getTime() - 24 * 60 * 60 * 1000) {
            return true;
          }
        },
      },
      tableData: [],
      materialList: [],

      loading: false,
      page: {
        isShow: true,
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      searchForm: {
        date: [
          commonUtils.timestampToDate(
            new Date().getTime() - 30 * 24 * 60 * 60 * 1000,
            true
          ),
          commonUtils.timestampToDate(new Date().getTime() - 24 * 60 * 60 * 1000, true),
        ],

        endDate: "",
        startDate: "",
        materialId: "",
        materialQualityName: "",
        propertyExtendList: [{ values: [], inputType: 1, index: 0 }],
      },
      query: {
        queryType: 2,
      },
      page: {
        isShow: true,
        total: 0,
        pageSize: 10,
        pageNum: 1,
      },
      tableTotalPage: 100,
      tableCurrentPage: 1,
      permission: JSON.parse(localStorage.getItem("permission")),
    };
  },
  mounted: async function () {
    this.init();
    this.materialList = await this.loadMaterialList();
  },
  methods: {
    sizeChange(ev) {
      this.page.pageSize = ev;
      this.btnPressType = 2;
      this.search();
    },
    pageChange: function (targetPage) {
      this.tableCurrentPage = targetPage;
      this.btnPressType = 3;
      this.search();
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
    formatHourMin(sec) {
      const hour = Math.floor(sec / 3600);
      const min = ((sec - hour * 3600) / 60).toFixed(0);
      if (hour != "0") {
        return hour + "小时" + min + "分钟";
      } else {
        return min + "分钟";
      }
    },
    async loadMaterialList(materialCode, materialName) {
      let { data } = await this.$RequestUtil.getAsync({
        url: "/api/select/selectMaterial",
        type: "sync",
        params: { materialCode, materialName },
      });
      return data;
    },
    async remoteMethod(type, materialCode, materialName) {
      this.loading = true;
      this.materialList = await this.loadMaterialList(materialCode, materialName);
      this.loading = false;
    },
    async clearSearchMaterial(type) {
      this.remoteMethod(type);
    },
    clearSearch() {
      this.searchForm = {
        date: [
          commonUtils.timestampToDate(
            new Date().getTime() - 30 * 24 * 60 * 60 * 1000,
            true
          ),
          commonUtils.timestampToDate(new Date().getTime() - 24 * 60 * 60 * 1000, true),
        ],
        materialId: "",
        materialQualityName: "",
        endDate: "",
        startDate: "",
      };
      this.btnPressType = 2;
    },
    init: function () {
      this.search();
      this.loadReasonCount();
    },
    loadReasonCount() {
      this.$RequestUtil.get({
        url: "/api/report/reason-count",
        params: {
          startDate: this.searchForm.date ? this.searchForm.date[0] : "",
          endDate: this.searchForm.date ? this.searchForm.date[1] : "",
          materialInfo: this.searchForm.materialId,
        },
        success: (res) => {
          if (res.code === 0) {
            this.drawHistoryChart(res.data);
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },

    clickSearch() {
      this.$refs["form"].validate((valid) => {
        this.query.queryType = this.searchForm.queryType;
        if (valid) {
          this.page.currentPage = 1;
          this.search(1);
          this.loadReasonCount();
        }
      });
    },
    pageChange(pageNum) {
      this.search(pageNum);
    },
    search(pageNum) {
      if (pageNum == null || pageNum instanceof KeyboardEvent) {
        pageNum = 1;
      }
      if (this.btnPressType == 2 || this.isChange) {
        this.tableCurrentPage = 1;
      }
      this.$RequestUtil.loading();
      this.$RequestUtil.get({
        url: "/api/report/newProcedureQcTask",
        type: "sync",
        params: {
          startDate: this.searchForm.date ? this.searchForm.date[0] : "",
          endDate: this.searchForm.date ? this.searchForm.date[1] : "",
          materialInfo: this.searchForm.materialId,
          pageSize: this.page.pageSize,
          pageNum: this.tableCurrentPage,
        },
        success: (res) => {
          this.isChange = false;
          if (this.btnPressType == 2) {
            this.btnPressType = 0;
          }
          if (res.msg == "success") {
            this.tableData = res.data.list;
            this.page.total = res.data.total;
            this.tableTotalPage = res.data.total;
            // this.page.total = res.data.total;
            // if (res.data.total == 0) {
            // 	this.$message.warning("查询不到符合条件的数据");
            // }
          } else {
            this.$message.error(res.message || res.msg);
          }
          this.$RequestUtil.loading().close();
        },
      });
    },

    exportList() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.export();
        }
      });
    },

    export: function () {
      this.$confirm("是否确认导出?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          if (this.searchForm.date && this.searchForm.date.length == 2) {
            this.searchForm.startDate = this.searchForm.date[0];
            this.searchForm.endDate = this.searchForm.date[1];
          }
          let params = commonUtils.cloneObj(this.searchForm);
          params.materialInfo = params.materialId;
          delete params.materialId;
          delete params.date;
          params.pageSize = -1;
          params.pageNum = -1;
          let exportUrl = "/api/report/newProcedureQcTaskExport";
          let str = "?";
          for (let p in params) {
            if (params[p]) {
              str += `${p}=${params[p]}&`;
            }
          }
          let { code, data } = await this.$RequestUtil.getAsync({
            url: "/api/auth/checkToken",
            type: "sync",
            params: {},
          });
          if (data == 0 || code != 0) {
            this.$message.error("当前登录已过期");
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            localStorage.removeItem("permission");
            this.$router.push({ path: "/login" });
            return;
          }

          if (str.endsWith("&")) {
            str = str.slice(0, str.length - 1);
          }
          str += `&pageSize=0&token=${localStorage.getItem("token")}`;
          window.location.href = encodeURI(exportUrl + str);
        })
        .catch(() => {});
    },

    drawHistoryChart: function (data) {
      this.historyChart = this.$Echarts.getInstanceByDom(
        document.getElementById("historyChart")
      );
      if (!this.historyChart) {
        this.historyChart = this.$Echarts.init(document.getElementById("historyChart"));
      }

      this.historyChart.setOption({
        tooltip: {},
        title: {
          text: "不良品原因",
          top: 16,
          left: 24,
        },
        grid: {
          left: 80,
          top: 60,
          right: 80,
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#94A3B8",
            rotate: 10,
            interval: 0,
            padding: [5, 0, 0, 20],
          },

          axisTick: {
            alignWithLabel: true,
            lineStyle: {
              color: "#94A3B8",
            },
          },
          data: data.map((item) => item.reason),
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#94A3B8",
          },
          axisTick: {
            lineStyle: {
              color: "#94A3B8",
            },
          },
        },
        series: [
          {
            data: data.map((item) => item.count),
            type: "bar",
            barWidth: "12",
            itemStyle: {
              color: "#409EFF",
            },
            label: {
              show: true,
              position: "top",
              color: "#94A3B8",
            },
          },
        ],
      });
    },
  },
  watch: {
    searchForm: {
      handler() {
        this.isChange = true;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
#yearPicker {
  position: absolute;
  right: 50px;
  top: 35px;
}

.topChart {
  display: flex;
  gap: 16px;
  padding: 16px;
  margin-top: -20px;
}

#proportionChart {
  width: 537px;
  height: 419px;
  border-radius: 4px 4px 4px 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  flex: 1;
}

#historyChart {
  width: 1082px;
  height: 319px;
  border-radius: 4px 4px 4px 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  flex: 2.2;
}

.page {
  display: flex;
  justify-content: flex-end;
}

.total_page {
  margin-top: 20px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}

.warp {
  position: absolute;
  z-index: 2000;
  padding: 4px 14px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.add,
.del {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: cover;
  cursor: pointer;
  position: relative;
  top: 4px;
  margin-left: 5px;
}

.add {
  background: url("/static/img/add.png");
  background-size: cover;
}

.del {
  height: 17px;
  background: url("/static/img/del.png");
  background-size: cover;
}

@media screen and (max-width: 1380px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}

.el-input /deep/ .el-input-group__append,
.el-input /deep/ .el-input-group__prepend {
  padding: 0 5px;
  width: 50px;
  height: 28px;
  line-height: 28px;
  box-sizing: border-box;
}

#PressFeedingRecord .el-input-group {
  width: 230px;
}

.table_searchbar {
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/views/report/qualityReport/UnqualifiedReport.vue